(function () {
  if (window.ITMART24_PRODUCT_CARD_REVIEWS_ASSET_BOUND) return;
  window.ITMART24_PRODUCT_CARD_REVIEWS_ASSET_BOUND = true;

  var CARD_SELECTOR = '[data-itmart24-product-card-rating]';

  function getProductCardNodes() {
    return Array.prototype.slice.call(document.querySelectorAll(CARD_SELECTOR));
  }

  function getDecimal(value) {
    var normalized = Number(value || 0);
    var remainder = normalized % 1;

    if (remainder >= 0.3 && remainder <= 0.7) return 0.5;
    if (remainder > 0.7) return 1;

    return 0;
  }

  function formatReviewCount(count) {
    var safeCount = Number.isFinite(count) ? count : 0;
    return '(' + safeCount + ')';
  }

  function getSummaryCache() {
    window.ITMART24_PRODUCT_REVIEW_SUMMARIES = window.ITMART24_PRODUCT_REVIEW_SUMMARIES || {};
    return window.ITMART24_PRODUCT_REVIEW_SUMMARIES;
  }

  function storeSummary(detail) {
    var cache = getSummaryCache();

    if (detail.productId) {
      cache['id:' + String(detail.productId)] = detail;
    }

    if (detail.productHandle) {
      cache['handle:' + String(detail.productHandle)] = detail;
    }
  }

  function getStoredSummary(card) {
    var cache = getSummaryCache();
    var productId = String(card.getAttribute('data-itmart24-product-id') || '');
    var productHandle = String(card.getAttribute('data-itmart24-product-handle') || '');

    if (productId && cache['id:' + productId]) {
      return cache['id:' + productId];
    }

    if (productHandle && cache['handle:' + productHandle]) {
      return cache['handle:' + productHandle];
    }

    return null;
  }

  function updateRatingCard(card, detail) {
    if (!card || !detail) return;

    var ratingValue = Number(detail.averageOverall || 0);
    var reviewCount = Number(detail.totalReviews || 0);
    var ratingMax = Number(detail.ratingMax || 5);
    var ratingLabel = card.querySelector('[data-itmart24-rating-label]');
    var ratingStars = card.querySelector('[data-itmart24-rating-stars]');
    var ratingCountNode = card.querySelector('[data-itmart24-rating-count]');

    card.hidden = false;
    card.removeAttribute('hidden');

    if (ratingLabel) {
      ratingLabel.setAttribute('aria-label', 'Rated ' + ratingValue.toFixed(1) + ' out of ' + ratingMax);
    }

    if (ratingStars) {
      ratingStars.style.setProperty('--rating', String(Math.floor(ratingValue)));
      ratingStars.style.setProperty('--rating-max', String(ratingMax));
      ratingStars.style.setProperty('--rating-decimal', String(getDecimal(ratingValue)));
    }

    if (ratingCountNode) {
      ratingCountNode.textContent = formatReviewCount(reviewCount);
    }
  }

  function isMatchingCard(card, detail) {
    var productId = String(card.getAttribute('data-itmart24-product-id') || '');
    var productHandle = String(card.getAttribute('data-itmart24-product-handle') || '');

    return (productId && productId === String(detail.productId || ''))
      || (productHandle && productHandle === String(detail.productHandle || ''));
  }

  function getApiBase() {
    var sessionRoot = document.querySelector('[data-user-portal-session-root]');
    var configured = sessionRoot ? sessionRoot.getAttribute('data-user-portal-api') : '';
    return String(configured || 'https://user.itmart24.com/api').replace(/\/$/, '');
  }

  function buildProductContext(card) {
    var productId = String(card.getAttribute('data-itmart24-product-id') || '');
    var shopifyProductId = String(card.getAttribute('data-itmart24-shopify-product-id') || '');
    var productHandle = String(card.getAttribute('data-itmart24-product-handle') || '');
    var productName = String(card.getAttribute('data-itmart24-product-name') || '').trim();
    var vendorName = String(card.getAttribute('data-itmart24-vendor-name') || '').trim();

    return {
      productId: productId,
      shopifyProductId: shopifyProductId || productId,
      productHandle: productHandle,
      productName: productName,
      vendorName: vendorName
    };
  }

  function getResponseProduct(data) {
    return data && data.product && typeof data.product === 'object' ? data.product : null;
  }

  function isExactProductMatch(productContext, responseProduct) {
    if (!responseProduct) return false;

    var responseProductId = String(responseProduct.productId || '').trim();
    var responseShopifyProductId = String(responseProduct.shopifyProductId || '').trim();
    var responseProductHandle = String(responseProduct.productHandle || '').trim();
    var responseProductName = String(responseProduct.productName || '').trim().toLowerCase();
    var responseVendorName = String(responseProduct.vendorName || '').trim().toLowerCase();

    if (productContext.productHandle && responseProductHandle) {
      return productContext.productHandle === responseProductHandle;
    }

    if (productContext.shopifyProductId && responseShopifyProductId) {
      return productContext.shopifyProductId === responseShopifyProductId;
    }

    if (productContext.productId && responseProductId) {
      return productContext.productId === responseProductId;
    }

    if (productContext.productName && productContext.vendorName && responseProductName && responseVendorName) {
      return productContext.productName.toLowerCase() === responseProductName
        && productContext.vendorName.toLowerCase() === responseVendorName;
    }

    if (productContext.productName && responseProductName) {
      return productContext.productName.toLowerCase() === responseProductName;
    }

    return false;
  }

  async function fetchSummaryForCard(card) {
    var productContext = buildProductContext(card);
    var cacheKey = productContext.productId
      ? 'id:' + productContext.productId
      : 'handle:' + productContext.productHandle;

    if (
      !cacheKey
      || (
        window.ITMART24_PRODUCT_CARD_REVIEW_REQUESTS
        && window.ITMART24_PRODUCT_CARD_REVIEW_REQUESTS[cacheKey]
      )
    ) {
      return;
    }

    window.ITMART24_PRODUCT_CARD_REVIEW_REQUESTS = window.ITMART24_PRODUCT_CARD_REVIEW_REQUESTS || {};
    window.ITMART24_PRODUCT_CARD_REVIEW_REQUESTS[cacheKey] = true;

    try {
      var url = new URL(getApiBase() + '/public-reviews/product');

      if (productContext.productHandle) {
        url.searchParams.set('productHandle', productContext.productHandle);
      }
      if (productContext.productId) {
        url.searchParams.set('productId', productContext.productId);
        url.searchParams.set('shopifyProductId', productContext.shopifyProductId);
      }
      if (productContext.productName) {
        url.searchParams.set('productName', productContext.productName);
      }
      if (productContext.vendorName) {
        url.searchParams.set('vendorName', productContext.vendorName);
      }

      var response = await fetch(url.toString(), {
        credentials: 'include',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        throw new Error('Product review summary could not be loaded.');
      }

      var payload = await response.json();
      var data = payload && payload.data ? payload.data : null;
      var product = getResponseProduct(data);
      var summary = data && data.summary ? data.summary : null;

      if (!data || !product || !summary) return;
      if (!isExactProductMatch(productContext, product)) return;

      var detail = {
        productId: String(product.productId || productContext.productId || ''),
        productHandle: String(product.productHandle || productContext.productHandle || ''),
        averageOverall: Number(summary.averageOverall || 0),
        totalReviews: Number(summary.totalReviews || 0),
        ratingMax: 5
      };

      storeSummary(detail);
      document.dispatchEvent(new CustomEvent('itmart24:reviews-summary-updated', { detail: detail }));
    } catch (error) {
      console.warn('[ITMart24] Product card review summary failed to load.', error);
    } finally {
      delete window.ITMART24_PRODUCT_CARD_REVIEW_REQUESTS[cacheKey];
    }
  }

  function hydrateProductCards() {
    getProductCardNodes().forEach(function (card) {
      var storedSummary = getStoredSummary(card);

      if (storedSummary) {
        updateRatingCard(card, storedSummary);
        return;
      }

      fetchSummaryForCard(card);
    });
  }

  function containsProductCardNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(CARD_SELECTOR)) return true;
    return Boolean(node.querySelector && node.querySelector(CARD_SELECTOR));
  }

  function scheduleHydration() {
    window.requestAnimationFrame(function () {
      hydrateProductCards();
    });
  }

  document.addEventListener('itmart24:reviews-summary-updated', function (event) {
    var detail = event.detail || {};

    getProductCardNodes().forEach(function (card) {
      if (isMatchingCard(card, detail)) {
        updateRatingCard(card, detail);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateProductCards, { once: true });
  } else {
    hydrateProductCards();
  }

  window.addEventListener('load', scheduleHydration);
  window.setTimeout(hydrateProductCards, 400);
  window.setTimeout(hydrateProductCards, 1200);
  window.setTimeout(hydrateProductCards, 2500);

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var shouldHydrate = mutations.some(function (mutation) {
        return Array.prototype.slice.call(mutation.addedNodes || []).some(containsProductCardNode);
      });

      if (shouldHydrate) {
        scheduleHydration();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
